function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import React from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { AppLink } from '@finect/tabular-core/AppLink';
import { dataLayer } from '@finect/front-gtm';
import { getProductName, getProductPath, getProductManager } from '@finect/front-resources/Products';
import { Link } from 'react-router-dom';
import { TextEllipsis } from '../../../../TextEllipsis';
import { PRODUCT_TYPES_WITH_ICON } from '../../../productTypesWithIcon';
import { Icon } from './../../../../Icon';
var BankIcon = function BankIcon(_ref) {
  var bankIcon = _ref.bankIcon;
  return React.createElement(Icon, {
    size: 1,
    alt: "company",
    type: "company",
    image: bankIcon ? "/image/".concat(bankIcon) : null,
    margin: "0 18px 0 0",
    withBorder: true,
    lightDefaultIcon: true
  });
};
var ManagerIcon = function ManagerIcon(_ref2) {
  var managerIcon = _ref2.managerIcon,
    productType = _ref2.productType;
  return React.createElement(Icon, {
    size: 1,
    alt: "company",
    type: Object.keys(PRODUCT_TYPES_WITH_ICON).includes(productType) ? productType : 'company',
    image: managerIcon ? "/image/".concat(managerIcon) : null,
    margin: "0 9px 0 0",
    withBorder: true,
    color: "primaryM"
  });
};
export var ProductName = function ProductName(_ref3) {
  var item = _ref3.item,
    productType = _ref3.productType,
    _ref3$withLink = _ref3.withLink,
    withLink = _ref3$withLink === void 0 ? true : _ref3$withLink,
    _ref3$withManagerIcon = _ref3.withManagerIcon,
    withManagerIcon = _ref3$withManagerIcon === void 0 ? false : _ref3$withManagerIcon,
    _ref3$withBankIcon = _ref3.withBankIcon,
    withBankIcon = _ref3$withBankIcon === void 0 ? false : _ref3$withBankIcon,
    _ref3$withSPA = _ref3.withSPA,
    withSPA = _ref3$withSPA === void 0 ? false : _ref3$withSPA,
    _ref3$position = _ref3.position,
    position = _ref3$position === void 0 ? null : _ref3$position,
    context = _ref3.context;
  var entity = item.product.entity;
  var portfolio = item.portfolio || null;
  var path = getProductPath(_objectSpread({
    entity: entity
  }, {
    subtype: productType.id
  }), context);
  var productName = getProductName(entity, productType);
  var manager = getProductManager(item.product);
  var managerIcon = withManagerIcon && manager ? manager.icon : null;
  var bankIcon = portfolio ? portfolio.account.bank.organization.icon : null;
  var Name = function Name() {
    return React.createElement(TextEllipsis, {
      lines: 2
    }, productName);
  };
  var propsLink = withSPA ? {
    as: Link,
    to: path
  } : {
    href: path
  };
  var handleMoreInfo = function handleMoreInfo(evt) {
    var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    !withSPA && evt.preventDefault();
    var layer = {
      id: 'ProductCard',
      type: 'productClick',
      params: {
        product: item.product,
        position: position,
        element: element
      },
      callback: withSPA ? undefined : function () {
        window.location = "".concat(path);
      }
    };
    dataLayer(layer);
  };
  return React.createElement(Flex, {
    style: {
      alignItems: 'center'
    }
  }, withManagerIcon ? React.createElement(ManagerIcon, {
    managerIcon: managerIcon,
    productType: productType.id
  }) : withBankIcon ? React.createElement(BankIcon, {
    bankIcon: bankIcon
  }) : null, withLink && entity.alias ? React.createElement(AppLink, _extends({
    onClick: function onClick(event) {
      handleMoreInfo(event, 'title');
    }
  }, propsLink), React.createElement(Name, null)) : React.createElement(Name, null));
};